/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { DraggableDirective } from "app/directives/draggable.directive";

declare var $: any;

/**
 * Popup Dialog used when saving Tag Lists on the "Monitor Tags" Page.
 */
@Component({
    selector: 'ef-save-tag-list-dialog',
    templateUrl: './save-tag-list-dialog.component.html'
})
export class SaveTagListDialogComponent {

    /** Draggable Directive added to that the popup is draggable.  Referenced so that the position can be reset. **/
    @ViewChild(DraggableDirective) draggableDirective: DraggableDirective;

    /** Output used to throw an event when the Save Button is clicked passing along the currently entered name **/
    @Output()
    saveClicked = new EventEmitter<string>();

    /** Output used to throw an event when the Cancel Button is clicked **/
    @Output()
    cancelClicked = new EventEmitter<void>();

    /** Name being modeled by the UI **/
    name = "";

    /** Boolean Flag used to hold whether the UI should be enabled or not. */
    isUiEnabled = true;


    /**
     * Constructor
     */
    constructor() { }

    /**
     * Called by other Components to show this Dialog.  The original "name"
     * displayed to the User can be optionally set, if not set it will be 
     * the empty string.
     * 
     * This also resets the "Drag" position so that it appears in the same position
     * every time it is opened. 
     */
    public showDialog(name?: string): void {
        this.draggableDirective.reset();
        this.name = (name?.length > 0)? name : "";
        $("#saveTagListDialog").modal("show");
    }

    /**
     * Called by other Components to hide this Dialog.
     */
    public hideDialog(): void {
        $("#saveTagListDialog").modal("hide");
    }

    /**
     * Called by other Components to control whether the UI should 
     * be enabled or not.
     */
    setUiEnabled(isEnabled: boolean): void {
        this.isUiEnabled = isEnabled;
    }

    /**
     * Called by the UI when the "Cancel" Button is clicked.
     * Emits a "cancelClicked" Event.
     */
    onCancelClicked(): void {
        if (this.isUiEnabled) {
            this.cancelClicked.emit();
        }
    }

    /**
     * Called by the UI when the "Save" Button is clicked.
     * Emits a "saveClicked" Event.
     */
    onSaveClicked(): void {
        if (this.isUiEnabled) {
            this.saveClicked.emit(this.name);
        }
    }

}
